<template>
  <div class="dashboard">
    <div class="statistic-container">
      <a-tabs :tabBarGutter="16" @tabClick="{}">
        <a-tab-pane v-for="(item) in sourceStatisticData" :key="item.type">
          <template slot="tab">
            <source-statistic-card
              :source-type="item.type"
              :total="item.value"
            ></source-statistic-card>
          </template>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-row :gutter="16">
      <a-col
        :lg="24"
        :xl="16"
        style="
          margin-bottom: 16px;
          height: 395px;
          border-radius: 6px;
        "
      >
        <div class="current-alert-container">
          <div class="module-header" style="margin-bottom: 24px">当前告警</div>
          <div style="position: absolute; right: 20px; top: 17px">
            <severity-multi-select v-model="currentSeverity" style="max-width: 210px; min-width: 100px; margin-right: 8px"></severity-multi-select>
            <simple-select
              :options="sourceTypeOptions"
              :autoSelect="false"
              :label-in-value="false"
              v-model="currentSourceType"
            ></simple-select>
          </div>
          <alert-timeline
            :severity="currentSeverity"
            :sourceType="currentSourceType"
            @total="v => (currentAlertCount = v)"
            class="overflow-scroll-hidden"
            style="padding: 8px 19px 16px 16px; overflow: auto; height: 328px"
          ></alert-timeline>
        </div>
      </a-col>
      <a-col
        :sm="24"
        :lg="12"
        :xl="8"
        style="
          margin-bottom: 16px;
          height: 395px;
          border-radius: 6px;
        "
      >
        <div class="alert-trend-container">
          <div class="module-header" style="margin-bottom: 24px">
            近七日告警恢复趋势
          </div>
          <div style="position: absolute; right: 20px; top: 17px">
            <severity-multi-select v-model="alertTrendSeverity" style="max-width: 210px; min-width: 100px;"></severity-multi-select>
          </div>
          <a-spin :spinning="spinning['alertTrend']">
            <alert-trend-chart
              v-if="trendData.length"
              :chart-data="trendData"
              chart-id="alert-trend-chart"
              :height="320"
            ></alert-trend-chart>
            <div v-else style="height: 320px; position: relative; overflow: hidden;">
              <empty-component
                :body-style="{
                  height: '216px',
                  marginTop: '34px'
                }"
                :description-style="{
                  marginTop: '-28px'
                }"
              ></empty-component>
            </div>
          </a-spin>
        </div>
      </a-col>
      <a-col
        :sm="24"
        :lg="12"
        :xl="8"
        style="
          margin-bottom: 16px;
          height: 395px;
          border-radius: 6px;
        "
      >
        <div class="alert-source-top-container dashboard-alert-container">
          <div class="module-header" style="margin-bottom: 42px">
            近七日告警资源 TOP5
          </div>
          <div style="position: absolute; right: 20px; top: 16px">
            <severity-multi-select v-model="alertSourceSeverity" style="max-width: 210px; min-width: 100px;"></severity-multi-select>
            <simple-select
              :options="sourceTypeOptions"
              @input="v => (alertSourceType = v.value)"
              :autoSelect="false"
              :value="sourceTypeOptions[0]"
              style="margin-left: 8px"
            ></simple-select>
          </div>
          <a-spin :spinning="spinning['alertSource']">
            <alert-info-top
              :detail="topOfSource"
              v-if="topOfSource.length"
              :isUrl="true"
              paramKey="source_id"
            ></alert-info-top>
            <div v-else style="height: 320px; position: relative; overflow: hidden;">
              <empty-component
                :body-style="{
                  height: '216px',
                  marginTop: '34px'
                }"
                :description-style="{
                  marginTop: '-28px'
                }"
              ></empty-component>
            </div>
          </a-spin>
        </div>
      </a-col>
      <a-col
        :sm="24"
        :lg="12"
        :xl="8"
        style="
          margin-bottom: 16px;
          height: 395px;
          border-radius: 6px;
        "
      >
        <div class="alert-info-top-container dashboard-alert-container">
          <div class="module-header" style="margin-bottom: 42px">
            近七日告警信息 TOP5
          </div>
          <div style="position: absolute; right: 20px; top: 16px">
            <severity-multi-select v-model="alertInfoSeverity" style="max-width: 210px; min-width: 100px;"></severity-multi-select>
          </div>
          <a-spin :spinning="spinning['alertInfo']">
            <alert-info-top
              :detail="topOfName"
              v-if="topOfName.length"
              :isUrl="true"
              paramKey="name"
            ></alert-info-top>
            <div v-else style="height: 320px; position: relative; overflow: hidden;">
              <empty-component
                :body-style="{
                  height: '216px',
                  marginTop: '34px'
                }"
                :description-style="{
                  marginTop: '-28px'
                }"
              ></empty-component>
            </div>
          </a-spin>
        </div>
      </a-col>
      <a-col
        :sm="24"
        :lg="12"
        :xl="8"
        style="
          margin-bottom: 16px;
          height: 395px;
          border-radius: 6px;
        "
      >
        <div class="alert-date-container dashboard-alert-container">
          <div class="module-header">系统统计</div>
          <div class="date-statistics">
            <!-- <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">系统运行时长</p>
                <p style="font-size: 29px; color: #0a6dd9">
                  {{ getTime(systemCount.uptime) }}
                </p>
              </div>
            </a-col> -->
            <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">监控指标总数</p>
                <p style="font-size: 29px; color: #faad14">
                  {{ systemCount.item }}
                </p>
              </div>
            </a-col>
            <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">触发规则总数</p>
                <p style="font-size: 29px; color: #faad14">
                  {{ systemCount.trigger }}
                </p>
              </div>
            </a-col>
            <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">近 7 日告警总数</p>
                <p style="font-size: 29px; color: #ff5b73">
                  {{ alertCount.total }}
                </p>
              </div>
            </a-col>
            <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">近 7 日未恢复告警</p>
                <p style="font-size: 29px; color: #ff5b73">
                  {{ alertCount.unrecovered }}
                </p>
              </div>
            </a-col>
            <a-col :span="12" style="text-align: center; margin-top: 18px">
              <div class="date-statistics-container">
                <p class="title">近 7 日已恢复告警</p>
                <p style="font-size: 29px; color: #5fc367">
                  {{ alertCount.recovered }}
                </p>
              </div>
            </a-col>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment'
import {
  grayColor,
  greenColor,
  redColor,
  alertSourceTypes
} from '@/utils/const'
import {
  getAlertCount,
  getAlertTop,
  getAlertTrend
} from '@/api/alert'
import { getDatabaseCount } from '@/api/database'
import { getMiddlewareCount } from '@/api/middleware'
import { getNetworkDeviceCount } from '@/api/network-device'
import { getOSCount } from '@/api/os'
import { getServerCount } from '@/api/server'
import { getStorageCount } from '@/api/storage'
import { getApplicationCount } from '@/api/application'
import { getSiteCount } from '@/api/site'
import { getDomainCount } from '@/api/domain'
import { getSSLCertificateCount } from '@/api/ssl-certificate'
import { getSystemStatus } from '@/api/system'
import { humanizeTime } from '@/utils'
import SimpleSelect from '@/components/select/SimpleSelect'
import AlertInfoTop from '@/components/top/AlertInfoTop'
import AlertTrendChart from './modules/AlertTrendChart'
import SourceStatisticCard from './modules/SourceStatisticCard'
import SeverityMultiSelect from '@/components/select/SeverityMultiSelect.vue'

export default {
  name: 'Dashboard',
  components: {
    AlertInfoTop,
    AlertTimeline: () => import('@/components/timeline/AlertTimeline'),
    AlertTrendChart,
    SimpleSelect,
    SourceStatisticCard,
    SeverityMultiSelect,
    EmptyComponent: () => import('@/components/EmptyComponent.vue')
  },
  data () {
    const types = [
      'network_device',
      'storage',
      'server',
      'os',
      'middleware',
      'database',
      'application',
      'site',
      'domain',
      'ssl_certificate'
    ]
    const sourceStatisticData = types.map(type => {
      return {
        type,
        value: 0
      }
    })
    return {
      sourceStatisticData,
      currentSeverity: ['high', 'disaster'],
      currentSourceType: 'all',
      alertInfoSeverity: ['high', 'disaster'],
      alertSourceSeverity: ['high', 'disaster'],
      alertSourceType: 'all',
      alertTrendSeverity: ['high', 'disaster'],
      alertCount: {
        recovered: 0,
        unrecovered: 0,
        total: 0
      },
      systemCount: {
        item: 0,
        uptime: 0,
        trigger: 0
      },
      currentAlertCount: 0,
      sourceTypeOptions: [
        { label: '全部资源', value: 'all' },
        ...alertSourceTypes.map(item => {
          return { label: this.$t(`source_type.${item}`), value: item }
        })
      ],
      topOfSource: [],
      topOfName: [],
      trendData: [],
      spinning: {
        alertTrend: false,
        alertSource: false,
        alertInfo: false
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.spinning.alertTrend = true
      this.spinning.alertSource = true
      this.spinning.alertInfo = true

      Promise.all(this.sourceStatisticData.map(item => new Promise((resolve, reject) => {
        const func = this.getSourceCountFunc(item.type)
        if (func) {
          func().then(res => {
            let total = 0
            const data = res.data ? res.data.data : []
            if (data.length) {
              data.forEach(item => {
                total += item.value
              })
            }

            resolve({
              type: item.type,
              value: total
            })
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve({
            type: item.type,
            value: 0
          })
        }
      }))).then(res => {
        this.sourceStatisticData = res.sort((a, b) => b.value - a.value)
      })

      getAlertCount({
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm')
      }).then(res => {
        const data = res.data
        let total = 0
        data.data.forEach(item => {
          total += item.value
          this.alertCount[item.name] = item.value
        })
        this.alertCount.total = total
      })

      getSystemStatus().then(res => {
        const data = res.data
        for (const key in this.systemCount) {
          if (Object.hasOwnProperty.call(this.systemCount, key)) {
            this.systemCount[key] = data[key]
          }
        }
      })

      getAlertTop({
        top_of: 'source',
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        limit: 5,
        severity: this.alertTrendSeverity
      }).then(res => {
        this.topOfSource = res.data.data
      }).finally(() => { this.spinning.alertTrend = false })

      getAlertTop({
        top_of: 'name',
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        limit: 5,
        severity: this.alertTrendSeverity
      }).then(res => {
        this.topOfName = res.data.data
      }).finally(() => { this.spinning.alertInfo = false })

      getAlertTrend({
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        trend_of: 'recovered',
        severity: this.alertTrendSeverity
      }).then(res => {
        const data = res.data.data
        this.formatterTrend(data)
      }).finally(() => { this.spinning.alertSource = false })
    },
    colors (v) {
      if (v === '在线') return greenColor
      else if (v === '离线') return redColor
      else return grayColor
    },
    getTime (v) {
      const length = humanizeTime(v).split(' ').length
      if (length >= 6) {
        return humanizeTime(v).split(' ').slice(0, 4).join('')
      }
      return humanizeTime(v).split(' ').join('')
    },
    formatterTrend (data) {
      this.trendData = []
      const date = []
      data.forEach(item => {
        date.push(item.date)
      })
      for (const item of new Set(date)) {
        const split = item.split('-')
        const date = split[1] + '-' + split[2]
        const recovered = data.find(
          v => v.date === item && v.name === 'recovered'
        )
        const unrecovered = data.find(
          v => v.date === item && v.name === 'unrecovered'
        )
        const recoveredVal = recovered === undefined ? 0 : recovered.value
        const unrecoveredVal = unrecovered === undefined ? 0 : unrecovered.value
        const rate =
          parseInt((recoveredVal / (recoveredVal + unrecoveredVal)) * 10000) /
          100
        this.trendData.push(
          {
            date,
            type: 'total',
            alert: unrecoveredVal + recoveredVal,
            rate
          },
          {
            date,
            type: 'recovered',
            alert: recoveredVal,
            rate
          }
        )
      }
    },
    getSourceCountFunc (sourceType) {
      switch (sourceType) {
        case 'network_device':
          return getNetworkDeviceCount
        case 'storage':
          return getStorageCount
        case 'server':
          return getServerCount
        case 'os':
          return getOSCount
        case 'middleware':
          return getMiddlewareCount
        case 'database':
          return getDatabaseCount
        case 'application':
          return getApplicationCount
        case 'site':
          return getSiteCount
        case 'domain':
          return getDomainCount
        case 'ssl_certificate':
          return getSSLCertificateCount
        default:
          return undefined
      }
    }
  },
  watch: {
    alertInfoSeverity (v) {
      this.spinning.alertInfo = true
      getAlertTop({
        top_of: 'name',
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        limit: 5,
        severity: v
      }).then(res => {
        this.topOfName = res.data.data
      }).finally(() => { this.spinning.alertInfo = false })
    },
    alertSourceSeverity (v) {
      let params = {}
      this.spinning.alertSource = true
      if (this.alertSourceType !== 'all') {
        params = {
          severity: v,
          source_type: this.alertSourceType
        }
      } else {
        params = {
          severity: v
        }
      }
      getAlertTop({
        top_of: 'source',
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        limit: 5,
        ...params
      }).then(res => {
        this.topOfSource = res.data.data
      }).finally(() => { this.spinning.alertSource = false })
    },
    alertSourceType (v) {
      let params = {}
      this.spinning.alertSource = true
      if (v !== 'all') {
        params = {
          severity: this.alertSourceSeverity,
          source_type: v
        }
      } else {
        params = {
          severity: this.alertSourceSeverity
        }
      }
      getAlertTop({
        top_of: 'source',
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        limit: 5,
        ...params
      }).then(res => {
        this.topOfSource = res.data.data
      }).finally(() => { this.spinning.alertSource = false })
    },
    alertTrendSeverity (v) {
      this.trendData = []
      this.spinning.alertTrend = true
      getAlertTrend({
        datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        trend_of: 'recovered',
        severity: v
      }).then(res => {
        const data = res.data.data
        this.formatterTrend(data)
      }).finally(() => { this.spinning.alertTrend = false })
    }
  }
}
</script>

<style lang="less">
.dashboard {
  .statistic-container {
    .ant-tabs-bar {
      border: none;
      .ant-tabs-nav-container-scrolling {
        padding: 0 16px;
        .ant-tabs-nav {
          .ant-tabs-tab-active {
            text-shadow: none;
          }
          .ant-tabs-tab {
            padding: 0;
            margin: 0;
          }
          .ant-tabs-ink-bar {
            display: none !important;
          }
        }
        .ant-tabs-tab-prev {
          width: 16px;
          line-height: 16px;
          background: #f0f2f5;
          color: #096dd9;
          .ant-tabs-tab-prev-icon-target {
            font-size: 14px !important;
          }
        }
        .ant-tabs-tab-next {
          width: 16px;
          line-height: 16px;
          background: #f0f2f5;
          color: #096dd9;
          .ant-tabs-tab-prev-icon-target {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .current-alert-container {
    background: #fff;
    border-radius: 6px;
    padding: 18px 16px;
    box-sizing: border-box;
    position: relative;
    height: 395px;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
  }

  .alert-trend-container {
    background: #fff;
    border-radius: 6px;
    height: 395px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    padding: 18px 16px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
  }

  .dashboard-alert-container {
    background: #fff;
    border-radius: 6px;
    height: 395px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    padding: 18px 16px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
  }

  .alert-date-container {
    .date-statistics {
      .date-statistics-container {
        height: 90px;
        border-radius: 8px;
        padding-top: 14px;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 8px;
          left: 8px;
          bottom: 0;
          opacity: 0.06;
          border-radius: 8px;
          background: #096dd9;
        }
        p {
          margin: 0;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }

  .title {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
  }
  .monitor-card .ant-col p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
